/**
 * Represents the different types of in/outpatient definitions.
 */
export enum InOutpatientDefinitionTypeModel {
	/**
	 * Represents a pharmacy type.
	 */
	Pharmacy = 1,
	/**
	 * Represents a medical type.
	 */
	Medical = 2,
	/**
	 * Represents an excluded type.
	 */
	Excluded = 3
}
